import React from "react";
import AddProductMain from "../components/products/AddProductMain";
import Sidebar from "../components/sidebar";
import Header from "./../components/Header";

const AddProduct = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <AddProductMain />
      </main>
    </>
  );
};

export default AddProduct;
